<template>
  <div class="host_exposure_page">
    <h1>主播通话曝光报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from '../../components/CustomTable'

export default {
  components: {
    CustomTable
  },
  data() {
    return {
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      dateValue: this.$store.getters.dateOneDayBefore,
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate() - 1)
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      tableOptions: {
        defaultSort: {
          prop: 'date',
          order: 'ascending'
        },
        theader: [
          {
            name: 'date',
            label: '日期',
            sortable: true,
            fixed: true,
            width: '180px'
          },
          {
            name: 'channel',
            label: '平台',
            sortable: true,
            fixed: true,
            width: '180px'
          },
          {
            name: 'name',
            label: '主播名称',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'modelName',
            label: '主播机型',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'agentId',
            label: '代理ID',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'rid',
            label: '主播ID',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'level',
            label: '主播评级',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'newHost',
            label: '是否新主播',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'area',
            label: '主播所属地区',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'country',
            label: '主播所属国家',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'onlineTime',
            label: '主播在线时长',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'homePageUserCount',
            label: '主播首页曝光人数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'homePageCount',
            label: '主播首页曝光次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'profilePageExposeUserCount',
            label: '主播资料页曝光人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'profilePageExposeCount',
            label: '主播资料页曝光次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledUserCount',
            label: '主播被拨打人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledCount',
            label: '主播被拨打次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledMatchUserCount',
            label: '主播被匹配拨打人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledMatchCount',
            label: '主播被匹配拨打次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledMatchOKUserCount',
            label: '主播被匹配拨打成功人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledMatchOKCount',
            label: '主播被匹配拨打成功次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'actorCallUserCount',
            label: '用户主动拨打主播人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'actorCallCount',
            label: '用户主动拨打主播次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledUserGoldGtOneMinUserCount',
            label: '余额大于1分钟拨打人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledUserGoldGtOneMinCount',
            label: '余额大于1分钟拨打次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledUserGoldGtOneMinOkUserCount',
            label: '余额大于1分钟拨打成功人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledUserGoldGtOneMinOkCount',
            label: '余额大于1分钟拨打成功次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledUserGoldGtOneMinOkRate',
            label: '余额大于1分钟拨打次数成功率',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledFromNewUserUserCount',
            label: '新用户拨打人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'calledFromNewUserCount',
            label: '新用户拨打次数',
            sortable: true,
            fix: true,
            width: '240px'
          },
          {
            name: 'callingTime',
            label: '主播通话时长',
            sortable: true,
            fix: true,
            width: '240px'
          },
          {
            name: 'gainGold',
            label: '主播获得金币',
            sortable: true,
            fix: true,
            width: '240px'
          },
          {
            name: 'callSuccessPeoples',
            label: '成功通话人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'callSuccessCounts',
            label: '成功通话次数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'anchorActiveCallPeoples',
            label: '主播主动拨打人数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'anchorActiveCallCounts',
            label: '主播主动拨打次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'anchorCallSuccessPeoples',
            label: '主播主动拨打成功人数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'anchorCallSuccessCounts',
            label: '主播主动拨打成功次数',
            sortable: true,
            fix: true,
            width: '160px'
          }
        ]
      },
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.loading = false
    // this.getList();
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.reports_host_exposure,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.dateValue,
          channel: this.curChannel.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
      for (let i = 0; i < data.length; i++) {
        data[i].newHost = data[i].newHost == true ? 'true' : 'false'
      }
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_host_exposure +
        '?token=' +
        this.token +
        '&username=' +
        this.username +
        '&start=' +
        this.dateValue +
        '&channel=' +
        this.curChannel.selectValue
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.host_exposure_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
